import z from "zod";

export const executionObjectivesCompleteSchema = z.object({
  photos_attachments_attributes: z.array(z.object({
    id: z.string().optional(),
    file: z.custom<File>().optional(),
  })).optional(),
});

export type ExecutionObjectivesCompleteValidationSchema = z.infer<typeof executionObjectivesCompleteSchema>;
